import React from 'react';
import { arrayOf, oneOfType, string } from 'prop-types';
import { cn } from '../../utils';
import { spinner, spinnerAlternate, spinnerLarge, spinnerLogo, spinnerSmall } from './styles.scss';
import { useFirstLoadHold, useStyleVariants } from '../../hooks';
import LogoLoader from '../LogoLoader';

const variants = {
  alternate: spinnerAlternate,
  large: spinnerLarge,
  small: spinnerSmall
};

// Inline contexts (buttons, compact indicators) keep the plain ring; screen and
// section loading states show the animated SOC mark.
const INLINE_VARIANTS = new Set(['small', 'alternate']);
const LOGO_SIZE = 48;
const LOGO_SIZE_LARGE = 96;

const NO_PHRASES = [];

const Spinner = ({ variant, className = '' }) => {
  const variantList = [].concat(variant || []);
  const isInline = variantList.some((name) => INLINE_VARIANTS.has(name));
  const classNames = useStyleVariants(variants, variant);

  useFirstLoadHold(!isInline);

  if (isInline) {
    return <div className={cn(spinner, classNames, className)} data-testid="spinner"></div>;
  }

  return (
    <div className={cn(spinner, spinnerLogo, className)} data-testid="spinner">
      <LogoLoader size={variantList.includes('large') ? LOGO_SIZE_LARGE : LOGO_SIZE} phrases={NO_PHRASES} />
    </div>
  );
};

Spinner.propTypes = {
  variant: oneOfType([string, arrayOf(string)]),
  className: string,
};

export default Spinner;
